<template>
    <div class="score-page" :class="{'loading':loadingNow}">
        <h3>Score</h3>
        <form v-if="displayForm" @submit.prevent="makeQuery">
            <input type="text" placeholder="Ticker" v-model="filters.ticker1">
            <input type="text" placeholder="Ticker" v-model="filters.ticker2">
            <input type="text" placeholder="Ticker" v-model="filters.ticker3">
            <input type="text" placeholder="Ticker" v-model="filters.ticker4">
            <input type="text" placeholder="Ticker" v-model="filters.ticker5">
            <input type="text" placeholder="Ticker" v-model="filters.ticker6">
            <button class="btn">Query</button>
            <button class="btn" type="button" @click="clearFormData">Clear</button>
        </form>
        <div class="score-table-container">
            <table class="table score-table">
                <thead>
                    <tr @click="handleSort">
                        <th v-for="item in tableColumns"
                            :key="item[0]" 
                            :data-sort="item[0]" 
                            :class="{'current asc': item[0] == sortField && sortOrder == 'asc', 
                                    'current desc': item[0] == sortField && sortOrder == 'desc' }"
                            v-tooltip="{ content: item[1], classes: 'thTooltip',placement:'bottom' }">
                            {{item[0]}}
                        </th>
                    </tr>
                </thead>
                <tbody v-if="!errorMessage">
                    <tr v-for="item in sortedTableRows" :key="item.Ticker">
                        <td>{{item.Cap}}</td>
                        <td @click="updateTickerInfo(item.Ticker)" class="pointer">{{item.Ticker}}</td>
                        <td class="text-center" :style="setScoreColor(item.Score)">{{item.Score}}</td>
                        <td class="text-center" :style="setRisKtoGapColor(item.Risk)" >{{item.Risk}}</td>
                        <td class="text-center" :style="setRisKtoGapColor(item.EPS)" >{{item.EPS}}</td>
                        <td class="text-center" :style="setRisKtoGapColor(item.ROIC)" >{{item.ROIC}}</td>
                        <td class="text-center" :style="setRisKtoGapColor(item.FCF)" >{{item.FCF}}</td>
                        <td class="text-center" :style="setRisKtoGapColor(item.EBV)" >{{item.EBV}}</td>
                        <td class="text-center" :style="setRisKtoGapColor(item.GAP)">{{item.GAP}}</td>
                        <td>{{item.EDS}}</td>
                        <td>{{item['Next earnings']}}</td>
                        <td class="text-right">{{item['1y Target']}}</td>
                        <td class="text-right" :class="{'redBackground': parseFloat(item.Fee) > 0.5 }">
                            {{parseFloat(item.Fee).toFixed(2)}}%
                        </td>
                        <td>{{item.Sector}}</td>
                        <td>{{item.Notes}}</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="13" class="text-center">
                            {{errorMessage}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="flex f-wrap" v-if="currentTicker">
            <div class="info" :class="{'hidden': !currentTickerData.companyName}">
                <h4>{{currentTickerData.companyName}}</h4>
                <p class="address">
                    {{currentTickerData.address}},
                    {{currentTickerData.city}},
                    {{currentTickerData.state}},
                    {{currentTickerData.country}}
                </p>
                <div class="info-connect">
                    <a :href="currentTickerData.website" target="_blank" class="link">
                        <img src="../../assets/img/link.svg" alt="">
                        {{currentTickerData.website}}
                    </a>
                    <a :href="'tel:' + currentTickerData.phone" target="_blank">
                        <img src="../../assets/img/phone.svg" alt="">
                        {{currentTickerData.phone}}
                    </a>
                    <a :href="'fax:' + currentTickerData.phone" target="_blank">
                        <img src="../../assets/img/printer.svg" alt="">
                        {{currentTickerData.phone}}
                    </a>
                </div>
            </div>
            <div class="logo" :class="{'hidden': !currentTickerLogo}" >
                <img :src="currentTickerLogo" alt="Logo">
            </div>
            <div class="chart" :class="{'hidden': !currentTicker}">
                <TradingViewMini :darkTheme="darkTheme" :ticker="currentTicker" />
            </div>
            <div class="description" :class="{'hidden': !currentTickerData.description}">
                <h4>Description</h4>
                <p>
                    {{currentTickerData.description}}
                </p>
            </div>
            <div class="overview" :class="{'hidden': !currentTickerStats.marketcap}">
                <h4>Overview</h4>
                <div class="overview-block">
                    <div>
                        <span>Market Cap</span>
                        <span>{{addMoneyFormat(currentTickerStats.marketcap)}}</span>
                    </div>
                    <div>
                        <span>Market Cap Class</span>
                        <span>{{marketCapClass}}</span>
                    </div>
                    <div>
                        <span>Enterprise Value</span>
                        <span>{{addMoneyFormat(currentTickerStats.enterpriseValue)}}</span>
                    </div>
                    <div>
                        <span>Beta</span>
                        <span>{{currentTickerStats.beta ? currentTickerStats.beta.toFixed(2) : ''}}</span>
                    </div>
                    <div>
                        <span>Shares Outstanding</span>
                        <span>{{addMoneyFormat(currentTickerStats.sharesOutstanding)}}</span>
                    </div>
                    <div>
                        <span>Total Float</span>
                        <span>{{addMoneyFormat(currentTickerStats.float)}}</span>
                    </div>
                    <!-- <div>
                        <span>Held By Institutions</span>
                        <span>No data ?</span>
                    </div> -->
                    <div>
                        <span>Employee Count</span>
                        <span>{{currentTickerStats.employees}}</span>
                    </div>
                </div>
            </div>
            <div class="news" :class="{'hidden': !newsArr.length}">
                <h4>News</h4>
                <NewsBlock :class="{'loading':newsLoadingNow}" :news="newsArr" />
            </div>
            <div class="insider-transactions">
                <h4>Insider 
                    <button 
                        v-if="currentTickerInsiderTransactions.length === 0"
                        @click="getTickerInsiderTransactions(currentTicker)"
                        class="btn">
                        Query
                    </button> 
                    <span v-else>({{lastInsiderTransactions.length}})</span>
                </h4>
                <div class="insider-transactions-table-container" v-if="lastInsiderTransactions.length">
                    <table class="table insider-transactions-table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Date</th>
                                <th>Name</th>
                                <th>Title</th>
                                <th>Code</th>
                                <th>Price</th>
                                <th>Shares</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in lastInsiderTransactions" :key="index">
                                <td>{{item.directIndirect}}</td>
                                <td>{{moment(item.effectiveDate).format('MM/DD/YYYY')}}</td>
                                <td>{{item.fullName}}</td>
                                <td :title="item.reportedTitle">{{item.reportedTitle}}</td>
                                <td>{{item.tranCode}}</td>
                                <td class="text-right">{{item.tranPrice ? '$' + addCommasDecimal(item.tranPrice) : item.tranPrice}}</td>
                                <td class="text-right">{{addCommas(item.tranShares)}}</td>
                                <td class="text-right">{{item.tranValue >= 0 ? '$' + addCommas(item.tranValue) : '-$' + addCommas(Math.abs(item.tranValue))}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="price-target">
                <h4>Price target</h4>
                <div class="price-target-block">
                    <div>
                        <span>Updated date</span>
                        <span>{{currentTickerPriceTarget.updatedDate}}</span>
                    </div>
                    <div>
                        <span>Average</span>
                        <span>{{currentTickerPriceTarget.priceTargetAverage ? addCommasDecimal(currentTickerPriceTarget.priceTargetAverage) : currentTickerPriceTarget.priceTargetAverage}}</span>
                    </div>
                    <div>
                        <span>High</span>
                        <span>{{currentTickerPriceTarget.priceTargetHigh}}</span>
                    </div>
                    <div>
                        <span>Low</span>
                        <span>{{currentTickerPriceTarget.priceTargetLow}}</span>
                    </div>
                    <div>
                        <span>Number of analysts</span>
                        <span>{{currentTickerPriceTarget.numberOfAnalysts}}</span>
                    </div>
                    <div>
                        <span>Currency</span>
                        <span>{{currentTickerPriceTarget.currency}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import NewsBlock from '../common/NewsBlock';
import TradingViewMini from '../common/TradingViewMini';

const TOKEN =  'pk_7d51a9a624ed43e8adfe4eb3b8d218d0';

export default {
    name: 'Score',
    props:['darkTheme'],
    components: {
        NewsBlock,
        TradingViewMini
    },
    data: () => ({
        loadingNow:false,
        displayForm:true,
        newsLoadingNow:false,
        currentTicker:'',
        sortField:'Ticker',
        sortOrder:'asc',
        filters:{
            ticker1:'',
            ticker2:'',
            ticker3:'',
            ticker4:'',
            ticker5:'',
            ticker6:'',
        },
        tableColumns:[
            ['Cap'],
            ['Ticker'],
            ['Score'],
            ['Risk','Our stock ratings are based on 5 metrics that assess the risk versus reward of a stock.'],
            ['EPS','Economic Earnings represent the true earnings for shareholders. Economic earnings incorporate 30+ adjustments to reported earnings based on information from the footnotes and MD&A.'],
            ['ROIC','Return on Invested Capital (ROIC) measures how much profit a company generates for every dollar invested in it over its life.'],
            ['FCF','Free Cash Flow Yield (FCF / Enterprise Value) measures the amount of cash available for distribution to all stakeholders relative to the total value of the enterprise.'],
            ['EBV',"The Price to Economic Book Value (EBV) ratio measures the difference between the market's expectation for future profits and the no-growth value of the stock."],
            ['GAP','The Market-Implied Growth Appreciation Period (GAP) is the number of years that the market price implies the company will earn a ROIC greater than WACC on new investments.'],
            ['EDS'],
            ['Earnings Date'],
            ['1y Target'],
            ['Fee'],
            ['Sector'],
            ['Notes']
        ],
        NoSortingFields:['1y Target','Notes'],
        responseData:[],
        currentTickerData:{},
        currentTickerStats:{},
        currentTickerLogo:'',
        currentTickerInsiderTransactions:[],
        currentTickerPriceTarget:{},
        newsArr:[]
    }),
    computed:{
        marketCapClass(){
            let result = '';
            // > 10B
            if (this.currentTickerStats.marketcap >= 10000000000) result = 'Large'
            // 2B - 10B
            else if (this.currentTickerStats.marketcap >= 2000000000 && this.currentTickerStats.marketcap < 10000000000) result = 'Mid'
            // 300M - 2B
            else if(this.currentTickerStats.marketcap >= 300000000 && this.currentTickerStats.marketcap < 2000000000) result = 'Small'
            // 50M - 300M
            else if(this.currentTickerStats.marketcap >= 50000000 && this.currentTickerStats.marketcap < 300000000) result = 'Micro'
            return result;
        },
        tableRows(){
            let resultArr = [];
            if (this.responseData.status == "success"){
                for (const keySize in this.responseData.data) {
                    const smallMidLarge = this.responseData.data[keySize];
                    for (const key in smallMidLarge) {
                        smallMidLarge[key].Cap = keySize;
                        resultArr.push(smallMidLarge[key]);
                    }
                }
            }
            return resultArr;
        },
        sortedTableRows(){
            let tempArr = this.tableRows.slice();
            if (tempArr.length > 1){
                let returnValues = [1,-1];
                if(this.sortOrder == 'desc') returnValues.reverse();
                tempArr.sort((a,b) => {
                    if (a[this.sortField] > b[this.sortField]) return returnValues[0];
                    return returnValues[1];
                });
            }
            return tempArr;
        },
        errorMessage(){
            if (this.responseData.status == "error"){
                return this.responseData.message;
            }
            return '';
        },
        lastInsiderTransactions(){
            const lastMonthTransactions = this.currentTickerInsiderTransactions.filter(item => {
                let subtractMonth = new Date();
                subtractMonth.setDate(subtractMonth.getDate() - 30);
                return item.effectiveDate > subtractMonth.getTime();
            })
            return lastMonthTransactions;
        }
    },
    methods:{
        setScoreColor(value){
            let resultColor = '';
            value = +value;
            switch(true){
                case (value >= 6  && value <= 9): resultColor = 'background-color:rgb(14,171,105);color:var(--main-bg-color);';break;
                case (value >= 10  && value <= 12): resultColor = 'background-color:rgb(133, 197, 172);color:var(--main-bg-color);';break;
                case (value >= 25  && value <= 27): resultColor = 'background-color:rgb(214, 82, 113);color:var(--main-bg-color);';break;
                case (value >= 28  && value <= 30): resultColor = 'background-color:rgb(171,0,41);color:var(--main-bg-color);';break;
            }
            return resultColor;
        },
        setRisKtoGapColor(value){
            let resultColor = '';
            switch(+value){
                case 1: resultColor = 'background-color:rgb(14,171,105);color:var(--main-bg-color);';break;
                case 2: resultColor = 'background-color:rgb(133, 197, 172);color:var(--main-bg-color);';break;
                case 4: resultColor = 'background-color:rgb(214, 82, 113);color:var(--main-bg-color);';break;
                case 5: resultColor = 'background-color:rgb(171,0,41);color:var(--main-bg-color);';break;
            }
            return resultColor;
        },
        handleSort(e){
            if (this.NoSortingFields.includes(e.target.getAttribute('data-sort'))) return;
            this.sortField = e.target.getAttribute('data-sort');
            this.sortOrder =  e.target.classList.contains('asc') ? 'desc' : 'asc';
        },
        makeQuery(){
            let queryParameters = {
                params:{
                    symbols:''
                }
            };

            let tickersArr = [];
            for (const key in this.filters) {
                if (/^[a-zA-Z,]+$/.test(this.filters[key].trim())){
                    tickersArr.push(this.filters[key].trim().toUpperCase());
                }
            }
            queryParameters.params.symbols = tickersArr.join(',');

            this.clearTickerData();
            if(queryParameters.params.symbols){
                this.responseData = [];
                this.loadingNow = true;
                axios.get('proxy/get_score',queryParameters).then(response => {
                    this.responseData = response.data;
                    this.loadingNow = false;
                });
            }
        },
        getTickerData(ticker){
            axios.get(`https://cloud.iexapis.com/v1/stock/${ticker}/company?token=${TOKEN}`).then(response => {
                if (response.status == 200)
                this.currentTickerData = response.data;
            });
        },
        getTickerLogo(ticker){
            axios.get(`https://cloud.iexapis.com/v1/stock/${ticker}/logo?token=${TOKEN}`).then(response => {
                if (response.status == 200)
                this.currentTickerLogo = response.data.url;
            });
        },
        getTickerStats(ticker){
            axios.get(`https://cloud.iexapis.com/v1/stock/${ticker}/advanced-stats?token=${TOKEN}`).then(response => {
                if (response.status == 200)
                this.currentTickerStats = response.data;
            });
        },
        getTickerNews(ticker){
            this.newsLoadingNow = true;
            axios.get(`https://cloud.iexapis.com/v1/stock/${ticker}/news/last?token=${TOKEN}`).then(response => {
                if (response.status == 200){
                    this.newsArr = response.data;
                }
                this.newsLoadingNow = false;
            });
        },
        getTickerInsiderTransactions(ticker){
            axios.get(`https://cloud.iexapis.com/v1/stock/${ticker}/insider-transactions?token=${TOKEN}`).then(response => {
                if (response.status == 200)
                this.currentTickerInsiderTransactions = response.data
            });
        },
        getTickerPriceTarget(ticker){
            axios.get(`https://cloud.iexapis.com/v1/stock/${ticker}/price-target?token=${TOKEN}`).then(response => {
                if (response.status == 200)
                this.currentTickerPriceTarget = response.data
            });
        },
        clearTickerData(){
            this.currentTicker = '';
            this.currentTickerData = {};
            this.currentTickerStats = {};
            this.currentTickerLogo = '';
            this.newsArr = [];
            this.currentTickerInsiderTransactions = [];
        },
        updateTickerInfo(ticker){
            this.currentTicker = ticker;
            this.getTickerData(ticker);
            this.getTickerLogo(ticker);
            this.getTickerStats(ticker);
            this.getTickerNews(ticker);
            // clear Insider transactions
            this.currentTickerInsiderTransactions = [];
            this.getTickerPriceTarget(ticker);
        },
        clearFormData(){
            for (const key in this.filters) {
                this.filters[key] = ''
            }
            this.responseData = [];
            this.clearTickerData();
        }
    },
}
</script>>
<style lang="scss" scoped>
.score-page{
    form{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        @media (max-width: 600px) {
            justify-content: space-between;
        }
        & > *{
            margin-right: 10px;
            margin-bottom: 15px;
            width: 168px;
            &.btn{
                width: auto;
            }
            @media (max-width: 600px) {
                margin-right: 0px;
                width: 49% !important;
            }
        }
        input{
            text-transform: uppercase;
            &::placeholder{
                text-transform: none;
            }
        }
    }
    .score-table-container{
        position: relative;
        @media (max-width: 1250px) {
            overflow-y: hidden;
            overflow-x: scroll;
        }
        .score-table{
            width: 100%;
            min-width: 1200px;
            margin-bottom: 20px;
        }
    }
    .flex{
        justify-content: space-between;
        h4{
            font-weight: 600;
            font-size: 16px;
            color: var(--live-text-color);
            margin-top: 0px;
        }
        @media (max-width: 1100px) {
            & > div{
                margin-bottom: 20px;
            }
            .info,.description,.news,.insider-transactions{
                width: calc(100% - 330px) !important;
                min-width: auto !important;
            }
            .logo,.chart,.price-target{
                width: 310px !important;
                justify-content: center !important;
            }
            .info,.logo,.description{
                order:-1;
            }
            .chart{
                padding-top: 34px;
            }
            .overview{
                width: 310px;
                order:1;
                .overview-block{
                    width: auto !important;
                }
            }
            .insider-transactions,
            .price-target{
                order: 2;
            }
        }
        @media (max-width: 650px) {
            .info,
            .description,
            .news,
            .logo,
            .chart,
            .overview,
            .insider-transactions,
            .price-target{
                width: 100% !important;
                padding-top: 0;
            }
            .news{
                order: 1;
            }
        }
        @media (max-width: 340px) {
            .chart{
                margin-left: calc((100% - 310px)/2);
            }
        }
        .info{
            width: 40%;
            h4{
                margin-top: 20px;
            }
            .address{
                font-size: 13px;
                color: var(--live-text-color);
            }
            a{
                font-size: 13px;
                box-shadow: 0px 4px 10px rgba(160, 160, 160, 0.5);
                padding: 7px 7px 7px 31px;
                position: relative;
                border-radius: 10px;
                margin-right: 10px;
                margin-bottom: 10px;
                display: inline-block;
                color: var(--live-text-color);
                text-decoration: none;
                &.link{
                    text-decoration: underline;
                }
                img{
                    position: absolute;
                    left: 10px;
                    top: 9px;
                }
            }
        }
        .logo{
            display: flex;
            align-items: center;
            img{
                max-width: 100px;
            }
        }
        .chart{
            display: flex;
            justify-content: flex-end;
            margin-bottom: 20px;
        }
        .chart,.news{
            width: calc(60% - 320px);
            min-width: 310px;
        }
        .description{
            width: 40%;
            p{
                background: var(--input-bg-color);
                border: 1px solid var(--input-br-color);
                border-radius: 10px;
                padding: 13px;
                max-height: 294px;
                overflow: auto;
                font-size: 13px;
                color: var(--live-text-color);
            }
        }
        .overview{
            margin-bottom: 20px;
            .overview-block{
                width: 280px;
                background: var(--input-bg-color);
                border: 1px solid var(--input-br-color);
                box-sizing: border-box;
                border-radius: 10px;
                padding: 17px 24px;
                & > div{
                    display: flex;
                    justify-content: space-between;
                    border-bottom: 1px solid var(--input-br-color);
                    padding: 8px 0px;
                    &:last-child{
                        border: 0;
                    }
                }
                span{
                    font-size: 13px;
                    color: #667090;
                }
            }
        }
        .insider-transactions{
            width: calc(77% - 20px);
            h4{
                button{
                    margin-left: 10px;
                }
            }
            .insider-transactions-table-container{
                position: relative;
                background: var(--input-bg-color);
                border: 1px solid var(--input-br-color);
                box-sizing: border-box;
                border-radius: 10px;
                @media (max-width: 1100px) {
                    overflow-y: hidden;
                    overflow-x: scroll;
                }
                .insider-transactions-table{
                    width: 100%;
                    position: relative;
                    min-width: 800px;
                    thead {
                        display: table; 
                        width: 100%;
                    }
                    tbody{
                        display: block; 
                        max-height: 210px;
                        overflow-y: scroll;
                        tr {
                            display: table;
                            width: 100%;
                            background: var(--input-bg-color);
                        }
                    }
                    th,td{
                        max-width: 80px;
                        &:nth-child(1){
                            width: 5%;
                        }
                        &:nth-child(2){
                            width: 11%;
                        }
                        &:nth-child(3){
                            width: 16%;
                        }
                        &:nth-child(4){
                            width: 25%;
                        }
                        &:nth-child(5){
                            width: 7%;
                        }
                        &:nth-child(6){
                            width: 8%;
                        }
                        &:nth-child(7){
                            width: 8%;
                        }
                        &:nth-child(8){
                            width: 14%;
                        }
                    }
                    td{
                        &:nth-child(8){
                            @media (min-width: 1200px) {
                                width: 11.5%;
                            }
                        }
                    }
                }
            }
        }
        .price-target{
            width: 23%;
            .price-target-block{
                background: var(--input-bg-color);
                border: 1px solid var(--input-br-color);
                box-sizing: border-box;
                border-radius: 10px;
                padding: 17px 24px;
                & > div{
                    display: flex;
                    justify-content: space-between;
                    border-bottom: 1px solid var(--input-br-color);
                    padding: 8px 0px;
                    &:last-child{
                        border: 0;
                    }
                }
                span{
                    font-size: 13px;
                    color: #667090;
                }
            }
        }
    }
    .hidden{
        opacity: 0 !important;
        @media (max-width: 650px) {
            display: none !important;
        }
    }
    &.loading{
        pointer-events: none;
        table{
            min-height: 200px;
        }
        table:before{
            content: "";
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 5;
            background: var(--loading-bg);
        }
        table:after{
            content: "";
            width: 64px;
            height: 64px;
            background: url('../../assets/img/loader.svg') no-repeat;;
            position: absolute;
            z-index: 10;
            left:50%;
            top:50%;
            transform: translate(-50%,-50%);
        }
    }
    .redBackground{
        background-color:rgb(171,0,41);
        color:var(--main-bg-color);
    }
}
</style>